<template>
   <div
      class="card page mb-5 p-2"
      style="width: 1300px; margin: 0 auto; box-shadow: 10px 10px 5px #888888"
      id="v-content"
    >
      <p>
        <span
          class="float-right span_close"
          style="
            display: block;
            width: 20px;
            line-height: 20px;
            text-align: center;
            font-size: 25px;
          "
          @click="$router.go(-1)"
        >
          &times;
        </span>
      </p>
      <div style="margin: 0 auto; width: 1200px">
        <p style="margin: 20px 0 30px 0;">
          <span style="margin-right:50px;font-size:20px;">投诉信箱(审)</span>
        </p>
      <el-table :data="tableData" border>
         <el-table-column
            prop="truename"
            label="投诉人"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="投诉人手机号"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="decomplainanter"
            label="被投诉人"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            prop="jobs"
            label="职位"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="jobs"
            label="状态"
            width="100"
            align="center"
          >
          <template slot-scope="scope">
            <span :style="{color: scope.row.isopen == 0 ? 'green' : 'red'}">{{scope.row.isopen == 0 ? '未公开' : '已公开'}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="contexts"
            label="投诉内容"
            align="center"
          >
          </el-table-column>
           <el-table-column
            prop="inserttime"
            label="投诉时间"
            align="center"
            width="150"
          >
          <template slot-scope="scope">
            <span>{{ scope.row.inserttime | TimeFormat }}</span>
          </template>
          </el-table-column>
      </el-table>

      <el-pagination
        style="margin: 20px 20px 20px 0;text-align:right;"
        background
        :page-size="20"
        layout="prev, pager, next"
        :total="total"
        @current-change = "changePage">
      </el-pagination>
  </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: [],
        DialogVisible:false,
        form: {
          truename: "",
          phone: "",
          decomplainanter: "",
          jobs: "",
          isopen: 0,
          contexts: ""
        },
        isLoading: false,
        total: 0,
        pageIndex: 1
      }
    },
    filters: {
      TimeFormat(date) {
        if (!date) {
          return '';
        }
        let date1 = date.replace(/T/g, ' ')
        let time = date1.replace(/\.[\d]{0,3}/, '')
        return time
      }
    },
    methods: {
      getList() {
        this.$http.post("Dls/ComplaintMailboxSearch", {
          pageIndex: this.pageIndex
        }).then(res => {
          if (res.data.isok) {
            this.tableData = res.data.data
            this.total = res.data.recount
          }
        }).catch(err => {
          
        })
      },

      changePage(page) {
        this.pageIndex = page;
        this.getList()
      }
    },
    created() {
      this.getList()
    }
  }
</script>

<style></style>


// WEBPACK FOOTER //
// src/pages/managerComplaint.vue